/**
 * Las iniciales de una persona para su avatar: las dos primeras palabras del
 * nombre, o del correo si no tiene nombre.
 */
export function initials(person: { name?: string; email: string }): string {
  const source = (person.name ?? "").trim() || person.email;
  const words = source.split(/[\s@.]+/).filter(Boolean);
  return ((words[0]?.[0] ?? "") + (words[1]?.[0] ?? "")).toUpperCase() || "?";
}
